import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import AddInspectionAgencyBranchForm from '../Components/AddInspectionAgencyBranchForm';

export default function AddInspectionAgencyBranchPage() {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <AddInspectionAgencyBranchForm/>
      </Container>
    </Box>
  )
}
